import { createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-7b469fae")

_pushScopeId("data-v-7b469fae")
const _hoisted_1 = { class: "link-success" }
const _hoisted_2 = { class: "m-top-lg" }
const _hoisted_3 = { class: "dialog-footer" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_button = _resolveComponent("el-button")
  const _component_dialog_shell = _resolveComponent("dialog-shell")

  return (_openBlock(), _createBlock(_component_dialog_shell, {
    title: _ctx.$wordList.LinkSite,
    width: 400,
    footerType: "customize",
    onClose: _ctx.onClose
  }, {
    footer: _withId(() => [
      _createVNode("span", _hoisted_3, [
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: _ctx.onClose
        }, {
          default: _withId(() => [
            _createTextVNode(_toDisplayString(_ctx.$wordList.TabelFootSure), 1)
          ]),
          _: 1
        }, 8, ["onClick"])
      ])
    ]),
    default: _withId(() => [
      _createVNode("div", _hoisted_1, [
        _createVNode("img", {
          class: "link-success-icon",
          src: require('@/assets/image/succeed.png')
        }, null, 8, ["src"]),
        _createVNode("p", _hoisted_2, _toDisplayString(_ctx.$wordList.LinkSucceedTip.format(_ctx.account)), 1)
      ])
    ]),
    _: 1
  }, 8, ["title", "onClose"]))
})